"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECORDS_DEFAULT_LIMIT = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const TGLazyModalWeb_1 = __importDefault(require("../TGLazyModalWeb"));
const TGOptionLazyModalActionsWeb_1 = __importDefault(require("./TGOptionLazyModalActionsWeb"));
const TGOptionModalRowRendererWeb_1 = __importStar(require("./TGOptionModalRowRendererWeb"));
exports.RECORDS_DEFAULT_LIMIT = 100;
const TGOptionLazyModalWeb = (props) => {
    const { data, value, multiSelect, pathToValue, pathToLabel, searchText, refetch, setOpen, onDone, setSelectedOptions, } = props;
    const [state, setState] = react_1.useState(value);
    react_1.useEffect(() => {
        setState(prev => (prev.length === 0 && value.length > 0 ? value : prev));
    }, [value]);
    const setStateWrapper = react_1.useCallback((newState) => {
        setState(newState);
        if (!multiSelect) {
            setTimeout(() => {
                setOpen(false);
                onDone(newState);
            });
        }
    }, [setOpen, multiSelect, onDone]);
    react_1.useEffect(() => {
        setSelectedOptions([...state]);
    }, [state]);
    const [listDataKey, setListDataKey] = react_1.useState(0);
    const refresh = react_1.useCallback(() => setListDataKey(prev => prev + 1), []);
    const handleDone = () => {
        onDone(state);
    };
    const isNothingSelected = state.length === 0;
    const handleClearAll = () => {
        setStateWrapper([]);
        refresh();
    };
    const generalRowRendererProps = react_1.useMemo(() => ({
        multiSelect: !!multiSelect,
        pathToValue,
        pathToLabel,
    }), [multiSelect, pathToValue, pathToLabel]);
    const selectAllAssets = react_1.useCallback(() => {
        refetch(true, data => {
            setStateWrapper([...data]);
        });
    }, [refetch, setStateWrapper]);
    return (react_1.default.createElement(TGLazyModalWeb_1.default, Object.assign({}, props, { state: state, setState: setStateWrapper, actions: react_1.default.createElement(TGOptionLazyModalActionsWeb_1.default, { state: state, totalCount: props.totalCount, multiSelect: !!multiSelect, isNothingSelected: isNothingSelected, handleClearAll: handleClearAll, selectAllAssets: selectAllAssets }), rowRenderer: TGOptionModalRowRendererWeb_1.default, rowRendererProps: generalRowRendererProps, listDataKey: listDataKey, onDone: multiSelect ? handleDone : undefined, rowHeight: TGOptionModalRowRendererWeb_1.ROW_HEIGHT_WEB, searchText: searchText, handleSearchText: props.handleSearchText, data: data, fetchMoreData: props.fetchMoreData, loading: props.loading, error: props.error, isAllLoaded: props.isAllLoaded })));
};
exports.default = TGOptionLazyModalWeb;
//# sourceMappingURL=TGOptionLazyModalWeb.js.map